export default __webpack_public_path__ + "static/media/one-stop.61b9a529.jpg";